import React from 'react';
import { userUrl } from '@/constants/urls';
import NameCellWrapper from '@/components/table/NameCellWrapper';
import UserIcon from './UserIcon';

const UserNameCell = ({ user, asLink }) => (
  <NameCellWrapper className="td-user-name" name={user.name} link={asLink ? userUrl(user) : undefined}>
    <UserIcon archived={user.archived} approved={user.approved} />
    {user.name}
  </NameCellWrapper>
);

export default UserNameCell;
